import axios from 'axios';

/**
 * Fetch the billing dashboard composite data for an org.
 * @param {string} orgId - UUID of the organisation
 */
export async function getDashboard(orgId) {
  const res = await axios.get('/api/v1/billing/dashboard', { params: { org_id: orgId } });
  return res.data;
}

/**
 * Query the usage ledger with optional filters.
 */
export async function getLedgerEntries({ orgId, from, to, entryType, runId, page = 1, pageSize = 50 } = {}) {
  const res = await axios.get('/api/v1/ledger', {
    params: {
      org_id: orgId,
      from: from || undefined,
      to: to || undefined,
      entry_type: entryType || undefined,
      run_id: runId || undefined,
      page,
      page_size: pageSize,
    },
  });
  return res.data;
}

/**
 * Fetch ledger summary (totals by type) for an org.
 */
export async function getLedgerSummary({ orgId, from, to } = {}) {
  const res = await axios.get('/api/v1/ledger/summary', {
    params: { org_id: orgId, from: from || undefined, to: to || undefined },
  });
  return res.data;
}

/**
 * Fetch org-level analytics summary (revenue, margin).
 */
export async function getOrgAnalytics({ orgId, from, to } = {}) {
  const res = await axios.get('/api/v1/analytics/org-summary', {
    params: { org_id: orgId, from: from || undefined, to: to || undefined },
  });
  return res.data;
}

/**
 * Fetch platform-wide analytics (admin only).
 */
export async function getPlatformAnalytics({ from, to } = {}) {
  const res = await axios.get('/api/v1/analytics/platform', {
    params: { from: from || undefined, to: to || undefined },
  });
  return res.data;
}

/**
 * Export ledger entries as CSV string (client-side from fetched data).
 * Returns a data URI for download.
 */
export function exportLedgerCsv(entries) {
  const headers = [
    'id', 'created_at', 'entry_type', 'model_name',
    'input_tokens', 'output_tokens', 'cache_read_tokens', 'cache_creation_tokens',
    'model_cost_credits', 'runtime_cost_credits', 'tool_cost_credits',
    'storage_cost_credits', 'total_cost_credits', 'total_cost_gbp',
    'run_id', 'user_id', 'tier', 'source_event',
  ];
  const rows = entries.map(e =>
    headers.map(h => {
      const v = e[h] ?? '';
      return `"${String(v).replace(/"/g, '""')}"`;
    }).join(',')
  );
  const csv = [headers.join(','), ...rows].join('\n');
  return 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
}
